import { combineReducers } from 'redux'

import createProducer  from './create/Reducer'
import updateProducer  from './update/Reducer'
import readProducers   from './read/Reducer'
import deleteProducers from './delete/Reducer'

export default combineReducers({
	createProducer,
	updateProducer,
	readProducers,
	deleteProducers
})